import type { LucideIcon } from "lucide-react"

import { cn } from "@/lib/utils"

interface OnboardingEmptyStateProps {
  icon: LucideIcon
  title: string
  description: string
  className?: string
  children?: React.ReactNode
}

export function OnboardingEmptyState({
  icon: Icon,
  title,
  description,
  className,
  children,
}: OnboardingEmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-1 flex-col items-center justify-center p-4 text-center",
        className,
      )}
    >
      <div className="bg-muted mb-4 flex h-12 w-12 items-center justify-center rounded-full">
        <Icon className="text-muted-foreground h-6 w-6" />
      </div>
      <h2 className="text-lg font-semibold">{title}</h2>
      <p className="text-muted-foreground mt-1 max-w-sm">{description}</p>
      {children}
    </div>
  )
}
